import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import classNames from 'classnames';
import { Button, CircularProgress } from '@material-ui/core';
import './Login.css';
import googleImg from '../Images/google_96px.png';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { signup } from '../Backend/firebase/auth';

function Register(props) {
    const { register, handleSubmit, reset, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);

    const routeOnLogin = async (user) => {
        const token = await user.getIdTokenResult();
        if (token.claims.admin) {
            props.history.push('/users');
        } else {
            //props.history.push(`/profile/${user.uid}`);
            console.info('Route');
            window.location.reload();
        }
    }

    const onSubmit = async (data) => {
        let user;
        setIsLoading(true);
        try {
            data.userRole = "User";
            user = await signup(data);
            reset();
            console.info("Success");
        } catch (error) {
            console.log(error);
        }

        if (user) {
            await routeOnLogin(user);
        } else {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="login">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <input type="hidden" name="userRole" ref={register} />
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Email Address</label>
                                <input type="email" className={classNames("form-control login__textbox", { "is-invalid": errors.email })}
                                    name="email" placeholder="Email Address" autoComplete="off"
                                    ref={register({ required: 'Please enter your email address!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Full Name</label>
                                <input type="text" className={classNames("form-control login__textbox", { "is-invalid": errors.fullName })}
                                    name="fullName" placeholder="Full Name" autoComplete="off"
                                    ref={register({ required: 'Please enter your full name!' })} />
                                <small className="form-text text-danger">{errors.fullName && errors.fullName.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Password</label>
                                <input type="password" className={classNames("form-control login__textbox", { "is-invalid": errors.password })}
                                    name="password" placeholder="Password" autoComplete="off"
                                    ref={register({
                                        required: 'Please enter your password!',
                                        minLength: {
                                            value: 6,
                                            message: 'Password should be at least 6 characters!'
                                        },
                                        maxLength: {
                                            value: 100,
                                            message: 'Password should be 15 length maximum!'
                                        }
                                    })} />
                                <small className="form-text text-danger">{errors.password && errors.password.message}</small>
                            </div>
                        </div>
                        <div className="col-sm-12 text-center mt-2">
                            <div className="d-flex justify-content-center">
                                <div className="p-2">
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btn">Register</Button>
                                </div>
                                <div className="p-2">
                                    {isLoading ? <CircularProgress size={20} /> : ''}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 text-center">
                            <div className="d-flex flex-column">
                                <div className="login__providersLogin">
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btnGoogle">
                                        <img src={googleImg} alt="google" className="img-fluid login__btnGoogleImage" />&nbsp;
                                        <span>Register with Google</span>
                                    </Button>
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btnLinkedIn">
                                        <LinkedInIcon className="login__btnLinkedInImage" />&nbsp;
                                        <span>Register with LinkedIn</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Register
